import React, { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { HeroTeaser } from '@vwfs-bronson/bronson-react';

interface Props {
  formData?: any;
}

export const ESignRefusedPage: FunctionComponent<Props> = () => {
  const { t } = useTranslation();

  return (
    <HeroTeaser
      imgProps={{
        sizes: '100vw',
        src: 'assets/img/bg_imgc.png',
      }}
      title={[
        <>
          <h3 className="u-mb-small" style={{ color: '#ffffff' }}>
            {t('eSignRefusedPage:title1')}
          </h3>
          <p className="u-font-size-fs3">{t('eSignRefusedPage:text1')}</p>
        </>,
      ]}
      sub={
        <p style={{ lineHeight: '1.2' }} className="u-font-size-fs3">
          <strong>{t('eSignRefusedPage:text2Prefix')}</strong> {t('eSignRefusedPage:text2Body')}
        </p>
      }
    />
  );
};
